export const ORDER_DATE_GENERAL_FORMAT = 'dd/MM/yyyy hh:mm';
export const TIME_DURATION = 4000;
export const VALID_AGE = 18;
export const SECONDS_IN_DAY = 86400;
export const SECONDS_IN_HOUR = 3600;
export const SECONDS_IN_MINUTE = 60;
export const MILLISECONDS_IN_SECOND = 1000;
export const GA_EVENT_SERVER_LOG_KEY = 'GA_EVENT_SERVER_LOG';
export const ENABLED = 'enabled';
export const DISABLED = 'disabled';

export const FOOD_CATEGORY = '1cc17afc-c78e-40f5-a0c8-b0e87b86b7ed';
